import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthService } from '../services/auth.service';

import { MasterPage } from './master.page';

const routes: Routes = [
  {
    path: 'wallet',
    canActivate: [AuthService],
    component: MasterPage,
    children: [
      {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
      },
      {
        path: 'extract/transactions',
        loadChildren: () => import('./pages/extract/all-transactions/all-transactions.module').then( m => m.AllTransactionsPageModule)
      },
      {
        path: 'extract/details/:id',
        loadChildren: () => import('./pages/extract/transaction-details/transaction-details.module').then( m => m.TransactionDetailsPageModule)
      },
      {
        path: 'bank',
        loadChildren: () => import('./pages/bank/bank-list/bank-list.module').then( m => m.BankListPageModule)
      },
      {
        path: 'bank/new',
        loadChildren: () => import('./pages/bank/bank-edit/bank-edit.module').then( m => m.BankEditPageModule)
      },
      {
        path: 'bank/:id/edit',
        loadChildren: () => import('./pages/bank/bank-edit/bank-edit.module').then( m => m.BankEditPageModule)
      },
      {
        path: 'deposit/make',
        loadChildren: () => import('./pages/deposit/make-deposit/make-deposit.module').then( m => m.MakeDepositPageModule)
      },
      {
        path: 'transfer/between-users',
        loadChildren: () => import('./pages/transfer/transfer-between-users/transfer-between-users.module').then( m => m.TransferBetweenUsersPageModule)
      },
      {
        path: 'withdraw',
        loadChildren: () => import('./pages/withdraw/withdraw.module').then( m => m.WithdrawPageModule)
      },
      {
        path: 'exchange',
        loadChildren: () => import('./pages/exchange/exchange.module').then( m => m.ExchangePageModule)
      },
    ]
  },
  {
    path: '',
    redirectTo: 'wallet/home',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MasterPageRoutingModule { }
